import { defineEndpoint } from '@nzyme/rpc/defineEndpoint.js';
import * as z from 'zod/mini';
import { Id } from '@sigma/common/schema/Id.js';
export const ChatMarkReadEndpointParams = z.object({
    /** ID of the chat to mark as read */
    chatId: Id,
    /** Sequence number of the last read event */
    seq: z.int32(),
});
/**
 * Endpoint to acknowledge a specific chat event.
 * Updates the patient read mark for the specified event.
 */
export const ChatMarkReadEndpoint = defineEndpoint({
    name: 'ChatMarkRead',
    input: ChatMarkReadEndpointParams,
});
//# sourceMappingURL=ChatMarkReadEndpoint.js.map